import { render } from "./ClientCMSDataSync.vue?vue&type=template&id=2bf894d8&scoped=true"
import script from "./ClientCMSDataSync.vue?vue&type=script&lang=js"
export * from "./ClientCMSDataSync.vue?vue&type=script&lang=js"

import "./ClientCMSDataSync.vue?vue&type=style&index=0&id=2bf894d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf894d8"]])

export default __exports__